/**
 * Simple cache for pagination data that preserves data between page navigations
 */
const PageCache = {
  _cache: {},
  /**
   * Store page data in cache
   * @param {string} key - Cache key (component identifier)
   * @param {number} page - Page number
   * @param {array} data - Data to cache
   */
  storePage(key, page, data) {
    if (!this._cache[key]) {
      this._cache[key] = {};
    }
    // Create a deep copy to prevent reference issues
    this._cache[key][page] = JSON.parse(JSON.stringify(data));
  },
  /**
   * Retrieve page data from cache
   * @param {string} key - Cache key
   * @param {number} page - Page number
   * @returns {array|null} - Cached data or null if not in cache
   */
  getPage(key, page) {
    if (!this._cache[key] || !this._cache[key][page]) {
      return null;
    }
    // Return a deep copy to prevent modifying the cache
    return JSON.parse(JSON.stringify(this._cache[key][page]));
  },
  /**
   * Clear cache for a specific component
   * @param {string} key - Cache key to clear
   */
  clearCache(key) {
    if (this._cache[key]) {
      this._cache[key] = {};
    }
  },

  /**
   * Clear cache for a specific page of a component
   * @param {string} key - Cache key
   * @param {number} page - Page number to clear
   */
  clearPage(key, page) {
    if (this._cache[key] && this._cache[key][page]) {
      delete this._cache[key][page];
    }
  }
};

export default PageCache;
